var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('share-feedback',{staticClass:"share-feedback-wrapper",attrs:{"feature":_vm.feature},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var openModal = ref.openModal;
return [_c('ds-text-button',{staticClass:"share-feedback-button",attrs:{"leading-icon":"message-square"},on:{"click":openModal}},[_vm._v(" "+_vm._s(_vm.$t('shareFeedback'))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }